import React from "react";
import { Link } from "react-router-dom";
import SidebarMenuBlocks from "../../components/adminNavigation/SidebarMenuBlocks";
import Button from "../../components/form/Button";
import { useSelector } from "react-redux";
import logo_image from "../../assets/images/logo.png";
import icon from "../../assets/images/fav.png";
import useFetch from "../../hooks/useFetch";
import { accessControlList } from "../../services/accessControlService";

const AdminSideBar = ({ isMenuOpen, setMenuOpen = () => {} }) => {
  const { session } = useSelector((state) => state?.authProvider);
  const message = useSelector((state) => state?.message);
  const { data } = useSelector((state) => state?.profile);
  const { siteSetting } = useSelector((state) => state?.setting);
  const { permissions } = useSelector((state) => state?.permission);
  const inactive_menus_code = permissions
    ?.filter((item) => item?.type?.list === false)
    ?.map((item) => item?.code);

  const adminSidebarMenu = [
    {
      _id: "1",
      menuTitle: "",
      menuData: [
        {
          _id: "1",
          menuLabel: "Dashboard",
          // code: "dashboard",
          menuLink: "/admin/dashboard",
          menuIcon: "fa-light fa-grid-2",
          menuIconColor: "text-chestnut-rose",
        },
      ],
    },
    {
      _id: "2",
      menuTitle: "Application Hub",
      menuData: [
        {
          _id: "1",
          menuLabel: "Scholarships",
          code: "scholarships",
          menuLink: "/admin/scholarships",
          menuIcon: "fa-light fa-graduation-cap",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "ScholarshipsApp",
          menuLabel: "Scholarship App",
          code: "scholarshipApp",
          menuLink: "/admin/scholarship-application/list",
          menuIcon: "fa-light fa-diploma",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "question",
          menuLabel: "Questions",
          code: "questions",
          menuLink: "/admin/questions",
          menuIcon: "fa-light fa-comment-question",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "2",
          menuLabel: "Eligibility Quiz",
          code: "eligibilityQuiz",
          menuLink: "/admin/quiz",
          menuIcon: "fa-light fa-puzzle",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "3",
          menuLabel: "App Forms",
          code: "appForms",
          menuLink: "/admin/appform",
          menuIcon: "fa-light fa-clipboard-list",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "1",
          menuLabel: (
            <div className="flex items-center gap-2">
              Communications{" "}
              {message?.messageCount > 0 && (
                <span className="flex items-center justify-center aspect-square w-7 h-7 text-white bg-chestnut-rose rounded-full text-xs">
                  {message?.messageCount > 99 ? "99+" : message?.messageCount}
                </span>
              )}
            </div>
          ),
          code: "communications",
          menuLink: "/admin/communications",
          menuIcon: "fa-light fa-tower-broadcast",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "Resource",
          menuLabel: "Resource",
          code: "resource",
          menuLink: "/admin/resources",
          menuIcon: "fa-regular fa-file",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "Contact",
          menuLabel: "Contact Us",
          code: "contactUs",
          menuLink: "/admin/contact-us",
          menuIcon: "fa-regular fa-address-book",
          menuIconColor: "text-chestnut-rose",
        },
      ],
    },
    {
      _id: "3",
      menuTitle: "Fund Management",
      menuData: [
        {
          _id: "1",
          menuLabel: "Donations",
          code: "donations",
          menuLink: "/admin/donations",
          menuIcon: "fa-light fa-hand-holding-dollar",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "2",
          menuLabel: "Finances",
          code: "fiances",
          menuLink: "/admin/finances",
          menuIcon: "fa-light fa-sack-dollar",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "3",
          menuLabel: "Payment Method",
          code: "paymentMethod",
          menuLink: "/admin/payment",
          menuIcon: "fa-light fa-money-bill",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "4",
          menuLabel: "Recurring Donations",
          code: "recurringDonations",
          menuLink: "/admin/subscription",
          menuIcon: "fa-regular fa-bell",
          menuIconColor: "text-chestnut-rose",
        },
      ],
    },
    {
      _id: "4",
      menuTitle: "User Management",
      menuData: [
        {
          _id: "1",
          menuLabel: "Users",
          code: "users",
          menuLink: "/admin/users",
          menuIcon: "fa-light fa-users",
          menuIconColor: "text-chestnut-rose",
        },
        // {
        //   _id: "2",
        //   menuLabel: "Access Control",
        //   menuLink: "/admin/accesscontrol",
        //   menuIcon: "fa-light fa-sliders",
        //   menuIconColor: "text-chestnut-rose",
        // },
      ],
    },
    {
      _id: "apply",
      menuTitle: "apply",
      menuData: [
        {
          _id: "eligibility",
          menuLabel: "Eligibility",
          code: "eligibility",
          menuLink: "/admin/eligibility",
          menuIcon: "fa-light fa-graduation-cap",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "timeline",
          menuLabel: "Timeline",
          code: "timeline",
          menuLink: "/admin/scholarship-timeline",
          menuIcon: "fa-light fa-timeline-arrow",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "faq",
          menuLabel: "FAQ",
          code: "faq",
          menuLink: "/admin/faq",
          menuIcon: "fa-light fa-square-question",
          menuIconColor: "text-chestnut-rose",
        },
        // {
        //   _id: "news",
        //   menuLabel: "News",
        //   menuLink: "/admin/news",
        //   menuIcon: "fa-light fa-newspaper",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "timeline",
        //   menuLabel: "Timeline",
        //   // menuLink: "/admin/timeline",
        //   menuLink: "/admin/timeline",
        //   menuIcon: "fa-light fa-timeline-arrow",
        //   menuIconColor: "text-chestnut-rose",
        // },
      ],
    },
    {
      _id: "5",
      menuTitle: "CMS Management",
      menuData: [
        {
          _id: "4",
          menuLabel: "Pages",
          code: "pages",
          menuLink: "/admin/pages",
          menuIcon: "fa-light fa-presentation-screen",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "Publications",
          menuLabel: "Publications",
          code: "publications",
          menuLink: "/admin/publications",
          menuIcon: "fa-light fa-books",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "PublicationCategories",
          menuLabel: "Publication Categories",
          code: "publicationCategories",
          menuLink: "/admin/publication/categories",
          menuIcon: "fa-light fa-icons",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "1",
          menuLabel: "Blogs",
          code: "blogs",
          menuLink: "/admin/blogs",
          menuIcon: "fa-light fa-blog",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "2",
          menuLabel: "Blogs Categories",
          code: "blogsCategories",
          menuLink: "/admin/blog/categories",
          menuIcon: "fa-light fa-icons",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "5",
          menuLabel: "Projects",
          code: "projects",
          menuLink: "/admin/projects",
          menuIcon: "fa-light fa-boxes-stacked",
          menuIconColor: "text-chestnut-rose",
        },

        {
          _id: "3",
          menuLabel: "Events",
          code: "events",
          menuLink: "/admin/events",
          menuIcon: "fa-light fa-calendar-days",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "partners",
          menuLabel: "Partners",
          code: "partners",
          menuLink: "/admin/partners",
          menuIcon: "fa-light fa-handshake",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "5",
          menuLabel: "Testimonials",
          code: "testimonials",
          menuLink: "/admin/testimonials",
          menuIcon: "fa-light fa-comment-smile",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "Sections",
          menuLabel: "Sections",
          code: "sections",
          menuLink: "/admin/sections",
          menuIcon: "fa-light fa-blog",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "6",
          menuLabel: "Email Templates",
          code: "emailTemplates",
          menuLink: "/admin/email-template",
          menuIcon: "fa-regular fa-envelope-open",
          menuIconColor: "text-chestnut-rose",
        },

        {
          _id: "7",
          menuLabel: "Site Settings",
          code: "siteSettings",
          menuLink: "/admin/site-settings",
          menuIcon: "fa-light fa-gear",
          menuIconColor: "text-chestnut-rose",
        },
      ],
    },
    // {
    //   _id: "6",
    //   menuTitle: "",
    //   menuData: [
    //     {
    //       _id: "1",
    //       menuLabel: "Settings",
    //       menuLink: "/admin/settings",
    //       menuIcon: "fa-light fa-gear",
    //       menuIconColor: "text-chestnut-rose",
    //     },
    //   ],
    // },
  ]
    ?.map((item) => ({
      ...item,
      menuData: item?.menuData?.filter(
        (menu) => !(inactive_menus_code || []).includes(menu?.code)
      ),
    }))
    ?.filter((item) => item?.menuData?.length > 0);

  const userSidebarMenu = [
    {
      _id: "1",
      menuTitle: "",
      menuData: [
        {
          _id: "home",
          menuLabel: "Go to Website",
          menuLink: "/",
          blank: true,
          menuIcon: "fa-regular fa-house",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "user-dashboard",
          menuLabel: "Dashboard",
          menuLink: "/user/dashboard",
          menuIcon: "fa-solid fa-table-cells",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "user-fa-solid fa-table-cells",
          menuLabel: "Applications",
          menuLink: "/user/applications",
          menuIcon: "fa-regular fa-envelope",
          menuIconColor: "text-chestnut-rose",
        },
        data?.donation && {
          _id: "user-donation",
          menuLabel: "Recurring Donations",
          menuLink: "/user/donation",
          menuIcon: "fa-regular fa-bell",
          menuIconColor: "text-chestnut-rose",
        },
        data?.donation && {
          _id: "user-donation",
          menuLabel: "Donations",
          menuLink: "/user/subscription",
          menuIcon: "fa-regular fa-hand-holding-circle-dollar",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "user-Communications",
          menuLabel: (
            <div className="flex items-center gap-2">
              Communications{" "}
              {message?.messageCount > 0 && (
                <span className="flex items-center justify-center aspect-square w-7 h-7 text-white bg-chestnut-rose rounded-full text-xs">
                  {message?.messageCount > 99 ? "99+" : message?.messageCount}
                </span>
              )}
            </div>
          ),
          menuLink: "/user/communications",
          menuIcon: "fa-regular fa-comments",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "user-Resources",
          menuLabel: "Resource Library",
          menuLink: "/user/resource-library",
          menuIcon: "fa-regular fa-file",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "user-Profile Information",
          menuLabel: "Profile Information",
          menuLink: "/user/profile",
          menuIcon: "fa-regular fa-clipboard",
          menuIconColor: "text-chestnut-rose",
        },
      ].filter(Boolean),
    },
  ];

  const donorSidebarMenu = [
    {
      _id: "1",
      menuTitle: "",
      menuData: [
        {
          _id: "home",
          menuLabel: "Go to Website",
          menuLink: "/",
          blank: true,
          menuIcon: "fa-regular fa-house",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "donor-dashboard",
          menuLabel: "Recurring Donations",
          menuLink: "/donor/donation",
          menuIcon: "fa-regular fa-bell",
          menuIconColor: "text-chestnut-rose",
        },
        data?.donation && {
          _id: "donor-dashboard",
          menuLabel: "Donations",
          menuLink: "/donor/subscription",
          menuIcon: "fa-regular fa-hand-holding-circle-dollar",
          menuIconColor: "text-chestnut-rose",
        },
      ].filter(Boolean),
    },
  ];

  const sidebarData =
    session?.user?.roleCode === "user"
      ? userSidebarMenu
      : session?.user?.roleCode === "admin"
      ? adminSidebarMenu
      : session?.user?.roleCode === "donor" && donorSidebarMenu;

  //

  return (
    <>
      <div className="relative w-full">
        <div
          className={
            `relative py-4 flex items-center gap-4 transition-all duration-100 z-60 border-slate-700` +
            (isMenuOpen ? "px-3" : "px-3")
          }
        >
          <Link className="h-12  mx-auto" to={"/"} replace>
            <img
              className="w-full h-full object-contain"
              src={siteSetting?.logo?.url}
              alt={"Logo"}
            />
          </Link>
        </div>
        <div
          className={
            "relative overflow-auto scroll-smooth scrollbar scrollbar-1 h-full max-h-[calc(100vh-9rem)] transition-all duration-100" +
            (isMenuOpen ? "" : "divide-transparent")
          }
        >
          {session?.status === "authorized" &&
            Array.isArray(sidebarData) &&
            sidebarData?.map((item, index) => {
              if (item) {
                return (
                  <SidebarMenuBlocks
                    key={item._id}
                    menuTitle={item.menuTitle}
                    menuData={item.menuData}
                    isMenuOpen={isMenuOpen}
                    icon={icon}
                  />
                );
              }
              return null;
            })}
        </div>
      </div>
    </>
  );
};

export default AdminSideBar;
